import { createContext, useContext, useState } from 'react';
import { MonitoreoService } from '../service/monitoreo/MonitoreoService';

const CatalogosContext = createContext();
const monitoreoService = new MonitoreoService();

export const CatalogosProvider = ({ children }) => {
    // Memoria caché global: { RIESGO: [...], PAISES: [...] }
    const [cacheCatalogos, setCacheCatalogos] = useState({});

    // Recuperar un solo catalogo
    const recuperarCatalogo = (url, nemonico) => {
        if (cacheCatalogos[nemonico]) {
            return Promise.resolve(cacheCatalogos[nemonico]);
        }
        // Si no está, vamos al backend
        return monitoreoService.consultarInfo(url, { nemonico: nemonico }).then((data) => {
            // Actualizamos la caché
            setCacheCatalogos((prev) => ({ ...prev, [nemonico]: data }));
            return data;
        }).catch((error) => {
            throw error;
        }).finally(() => {

        });
    };

    // Obtener multiples catalogos
    const obtenerCatalogos = (url, nemonicosArray) => {
        const faltantes = nemonicosArray.filter(nem => !cacheCatalogos[nem]);
        // Si hay faltantes, vamos al backend
        if (faltantes.length > 0) {
            const nemonicosString = faltantes.join(',');
            return monitoreoService.consultarInfo(url, { nemonicos: nemonicosString }).then((res) => {
                // Actualizamos la caché
                setCacheCatalogos(prev => ({ ...prev, ...res.data }));
                const resultadoFinal = {};
                nemonicosArray.forEach(nem => {
                    // Priorizamos lo nuevo
                    resultadoFinal[nem] = res.data?.[nem] || cacheCatalogos[nem] || [];
                });
                // Retornamos los catalogos solicitados
                return { data: resultadoFinal };
            }).catch((error) => {
                throw error;
            }).finally(() => {

            });
        }
        // Si no hay faltantes, resolvemos desde la caché
        const resultadoFinal = {};
        nemonicosArray.forEach(nem => { resultadoFinal[nem] = cacheCatalogos[nem]; });
        return Promise.resolve({ data: resultadoFinal });
    };

    // Iniciar todos los catalogos de un modulo
    const iniciarCatalogos = (url, nemonicosArray, params = {}, forceRefresh = false) => {
        // Si forceRefresh es true, ignoramos la caché y pedimos todo de nuevo
        const faltantes = forceRefresh ? nemonicosArray : nemonicosArray.filter(nem => !cacheCatalogos[nem]);
        // Si hay faltantes o forzamos el refresh, vamos al backend
        if (faltantes.length > 0) {
            return monitoreoService.consultarInfo(url, params).then((res) => {
                const nuevosCatalogos = res.data || {};
                // Actualizamos la caché
                setCacheCatalogos(prev => ({ ...prev, ...nuevosCatalogos }));
                const resultadoFinal = {};
                nemonicosArray.forEach(nem => {
                    // Priorizamos lo nuevo
                    resultadoFinal[nem] = nuevosCatalogos[nem] || cacheCatalogos[nem] || [];
                });
                // Retornamos los catalogos solicitados
                return { data: resultadoFinal };
            }).catch((error) => {
                throw error;
            });
        }
        // Si no hay faltantes, resolvemos desde la caché
        const resultadoFinal = {};
        nemonicosArray.forEach(nem => { resultadoFinal[nem] = cacheCatalogos[nem]; });
        return Promise.resolve({ data: resultadoFinal });
    };


    return (
        <CatalogosContext.Provider value={{ iniciarCatalogos, obtenerCatalogos, recuperarCatalogo }}>
            {children}
        </CatalogosContext.Provider>
    );
};

export const useCatalogos = () => {
    const context = useContext(CatalogosContext);
    if (!context) {
        throw new Error("useCatalogos debe ser usado dentro de un CatalogosProvider");
    }
    return context;
};